<template>
  <div class="container mt-4 border" >
    <div class="d-flex align-items-center justify-content-between">
      <div style="font-size: 18px;font-weight: bold;">Devices</div>
      <!-- Toolbar: ค้นหา / size / รีเฟรช -->
      <div class="d-flex align-items-center gap-2 mt-2 flex-nowrap" style="overflow:auto; white-space: nowrap;">
        <input
          v-model.trim="q"
          @keyup.enter="reload"
          type="search"
          class="form-control"
          placeholder="ค้นหาชื่อกลุ่ม (กด Enter)"
          style="max-width: 260px; min-width: 200px;"
        />
        <select v-model.number="size" class="form-select" style="width: 120px;">
          <option :value="10">10 / หน้า</option>
          <option :value="20">20 / หน้า</option>
          <option :value="50">50 / หน้า</option>
        </select>
        <button class="btn btn-outline-primary" :disabled="loading" @click="reload">
          {{ loading ? "กำลังโหลด..." : "รีเฟรช" }}
        </button>
      </div>
    </div>
    <table class="table table-bordered table-striped mt-3" style="">
      <thead class="mt-2">
        <tr>
          <th>No</th>
          <th>Device name</th>
          <th>Comment</th>
          <!-- <th>Hardware Type</th> -->
          <th>Communication</th>
          <!-- <th>Model</th> -->
          <th>Plan</th>
          <th>Edit</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="loading">
          <td colspan="6" class="text-center text-muted py-4">กำลังโหลดข้อมูล...</td>
        </tr>
        <tr v-else-if="total === 0">
          <td colspan="6" class="text-center text-muted py-4">ไม่พบข้อมูล</td>
        </tr>
        <tr v-else v-for="(itemdevice, index) in list_device" :key="index">
          <td class="text-center">{{ index+1 }}</td>
          <!-- <td>{{ itemdevice.id}}</td> -->
          <td>{{ itemdevice.name }}</td>
          <td>{{ itemdevice.comment }}</td>
          <td>{{itemdevice.mode}}</td>
          
          <!-- <td>{{ itemdevice.config.auth}}</td> -->
          <!-- <td>{{itemdevice.planId}}</td> -->
          <td>
              <div>
  {{ list_plan.find(item => item.id === itemdevice.planId)?.name || '-' }}
</div>
          </td>
          <td class="text-center">
            <button @click="openEditModal(itemdevice)" type="button" class="btn text-white py-1 px-2 rounded-4"
              data-bs-toggle="modal" data-bs-target="#editDeviceModal"
              style="background-color: rgb(47, 144, 220); font-size: 14px;">
              <font-awesome-icon :icon="['fas', 'pen']" /> Edit
            </button>
            <button @click="deleteDevice(itemdevice.id)" type="button"
              class="btn btn-danger text-white py-0 ms-1 py-1 px-2 rounded-4" style="font-size: 14px;">Delete</button>
          </td>
        </tr>
      </tbody>
    </table>
    <!-- Pagination -->
    <div class="d-flex justify-content-between align-items-center mt-2 mb-4">
        <div class="text-muted">
          ทั้งหมด: {{ total }} รายการ
        </div>
        <div class="btn-group">
          <button class="btn btn-outline-secondary" :disabled="page <= 1 || loading" @click="prevPage">ก่อนหน้า</button>
          <span class="btn btn-outline-secondary disabled">หน้า {{ page }}</span>
          <button class="btn btn-outline-secondary" :disabled="disableNext || loading" @click="nextPage">ถัดไป</button>
        </div>
      </div>
    <!-- Modal -->
    <div class="modal fade" id="editDeviceModal" tabindex="-1" aria-labelledby="editDeviceModalLabel"
      aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="editDeviceModalLabel">Edit Device</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="container">

              <div class="row">
                <div class="col-md-6">
                  <div class="mb-3">
                    <label class="form-label"><i class="bi bi-envelope"></i> Device name</label>
                    <input type="email" class="form-control" placeholder="Name" v-model="device.name">
                  </div>
                  <div class="mb-3">
                    <label class="form-label"><i class="bi bi-person-badge"></i>Communication</label>
                    <select class="form-select" v-model="device.mode">
                      <option value="mqtt">MQTT</option>
                      <option value="api">API</option>
                    </select>
                  </div>
                  <div class="mb-3 px-3 py-3 rounded-4 bg-light" v-if="device.mode=='mqtt'" style="">
                    <div class="row">
                      <label class="form-label"><i class="bi bi-card-list"></i>Topic</label>
                      <div class="col-10">
                        <input type="text" class="form-control" placeholder="Topic" v-model="mqtt.topic">
                      </div>
                      <div class="col-2 text-end">
                        <button type="button" class="btn btn-primary" @click="copyTextFallback(mqtt.topic)">Copy</button>
                      </div>
                    </div>
                    <div class="row">
                      <label class="form-label"><i class="bi bi-card-list"></i>ID</label>
                      <div class="col-10">
                        <input type="text" class="form-control" placeholder="ID" v-model="mqtt.clientId">
                      </div>
                      <div class="col-2 text-end">
                        <button type="button" class="btn btn-primary" @click="copyTextFallback(mqtt.clientId)">Copy</button>
                      </div>
                    </div>
                    <div class="row">
                      <label class="form-label"><i class="bi bi-card-list"></i>Username</label>
                      <div class="col-10">
                        <input type="text" class="form-control" placeholder="" v-model="mqtt.username">
                      </div>
                      <div class="col-2 text-end">
                        <button type="button" class="btn btn-primary"
                          @click="copyTextFallback(mqtt.username)">Copy</button>
                      </div>
                    </div>
                    <div class="row">
                      <label class="form-label"><i class="bi bi-card-list"></i>Password</label>
                      <div class="col-10">
                        <input type="text" class="form-control" placeholder="" v-model="mqtt.password">
                      </div>
                      <div class="col-2 text-end">
                        <button type="button" class="btn btn-primary"
                          @click="copyTextFallback(mqtt.password)">Copy</button>
                      </div>
                    </div>
                  </div>

                  <div v-else class="mb-3 px-3 py-3 rounded-4 bg-light" style="">
                    <div class="mb-3">
                      <label class="form-label"><i class="bi bi-person-badge"></i>API Type</label>
                      <select class="form-select" v-model="api.type">
                        <option value="apikey">API Key</option>
                        <option value="basic">Basic</option>
                      </select>
                    </div>

                    <div v-if="api.type=='apikey'">
                      <div class="mb-3">
                        <label class="form-label"><i class="bi bi-person-badge"></i>API Type</label>
                        <select class="form-select" v-model="api.in">
                          <option value="header">Header</option>
                          <option value="query">Query</option>
                        </select>
                      </div>
                      <label class="form-label"><i class="bi bi-card-list"></i>Key</label>
                      <div class="col-12">
                        <input type="text" class="form-control" placeholder="Key" v-model="api.key">
                      </div>

                      <label class="form-label mt-2"><i class="bi bi-card-list"></i>Value</label>
                      <div class="col-12">
                        <input type="text" class="form-control" placeholder="Value" v-model="api.value">
                      </div>
                    </div>
                    <div v-else-if="api.type=='basic'">

                      <label class="form-label"><i class="bi bi-card-list"></i>Username</label>
                      <div class="col-12">
                        <input type="text" class="form-control" placeholder="Username" v-model="api.username">
                      </div>

                      <label class="form-label mt-2"><i class="bi bi-card-list"></i>Password</label>
                      <div class="col-12">
                        <input type="text" class="form-control" placeholder="Password" v-model="api.password">
                      </div>
                    </div>
                  </div>
                  <!-- <div class="mb-3">
                    <label class="form-label"><i class="bi bi-card-list"></i> Model</label>
                    <input type="text" class="form-control" placeholder="Model eg.IOT2025" v-model="fullName">
                  </div> -->
                </div>
                <!-- Right Section -->
                <div class="col-md-6">
                  <div class="mb-3">
                    <label class="form-label"><i class="bi bi-bookmark"></i>Template</label>
                    <select class="form-select" v-model="device.template_id" id="">
                        <option v-for="item in list_template" :key="item" :value="item.id">
                            {{ item.name }}
                        </option>
                    </select>
                  </div>
                  <div class="mb-3">
                    <label class="form-label"><i class="bi bi-bookmark"></i>Plan</label>
                    <select class="form-select" v-model="device.plan_id" id="">
                        <option v-for="item in list_plan" :key="item.id" :value="item.id">
                            {{ item.name }}
                        </option>
                    </select>
                  </div>
                  <div class="mb-3">
                    <label class="form-label"><i class="bi bi-bookmark"></i> Note</label>
                    <textarea class="form-control" rows="4" placeholder="Add a note..."
                      v-model="device.comment"></textarea>
                  </div>
                </div>
              </div>
              <!-- Buttons -->
              <div class="d-flex justify-content-between mt-4">
                <button class="btn btn-danger px-4" @click="clearForm">
                  <i class="bi bi-brush"></i> Clear
                </button>
                <button class="btn btn-secondary px-4" @click="editDevice(device.id)">
                  <i class="bi bi-person-plus"></i> Edit Device
                </button>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        list_template:[],
        list_plan:[],
        loading: false,
        q: "",
        page: 1,
        size: 10,
        total: 0,
        device: {
                    template_id:"",
                    plan_id:"",
                    name: "",
                    note: "",
                    mode: "api",
                    model: "",

                },
        api: {
          type: "basic",
          in: "",
          key: "",
          value: "",
          username: "",
          password: ""
        },
        mqtt: {
          clientId: "cxaksjyteqhw",
          topic:"",
          username: "",
          password: ""
        },
        list_device: [
          // {name:"Test1",sn:"SN000001",model:"IOT1234",protocol:"RS485-modbus",},
          // {name:"Test2",sn:"SN000002",model:"IOT1234",protocol:"RS485-modbus",},
          // {name:"Test3",sn:"SN000003",model:"IOT1234",protocol:"RS485-modbus",}
        ],
      };
    },
    computed: {
      disableNext() {
        return this.page * this.size >= this.total;
      },
    },
    methods: {
      emptyDevice() {
        return {
          id: "",
          template_id: "",
          plan_id: "",
          name: "",
          note: "",
          comment: "",
          mode: "api",
          model: "",
        };
      },
      emptyApiConfig() {
        return {
          type: "basic",
          in: "",
          key: "",
          value: "",
          username: "",
          password: "",
        };
      },
      emptyMqttConfig() {
        return {
          clientId: "cxaksjyteqhw",
          topic: "",
          username: "",
          password: "",
        };
      },
      openEditModal(itemdevice) {
        const safeDevice = {
          ...this.emptyDevice(),
          ...(itemdevice || {}),
          template_id: itemdevice?.template_id ?? itemdevice?.templateId ?? "",
          plan_id: itemdevice?.plan_id ?? itemdevice?.planId ?? "",
        };
        const rawConfig = itemdevice?.config && typeof itemdevice.config === "object"
          ? itemdevice.config
          : {};
        const rawAuth = rawConfig?.auth && typeof rawConfig.auth === "object"
          ? rawConfig.auth
          : {};

        this.device = safeDevice;
        this.api = {
          ...this.emptyApiConfig(),
          ...rawAuth,
          type: rawAuth.type || this.emptyApiConfig().type,
        };
        this.mqtt = {
          ...this.emptyMqttConfig(),
          ...rawConfig,
        };
      },
      async getTemplateList() {
                try {
                    var accessToken = localStorage.getItem("accessToken");
                    const response = await fetch(`${process.env.VUE_APP_API_URL}/api/devices/template`, {
                        method: "GET",
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${accessToken}`
                        }
                    });
                    const data = await response.json();
                    console.log("success:", data);
                    this.list_template = data.data;
                } catch (error) {
                    console.error("Upload error:", error);
                }
            },
      async getPlanList() {
                try {
                    var accessToken = localStorage.getItem("accessToken");
                    const response = await fetch(`${process.env.VUE_APP_API_URL}/api/plan`, {
                        method: "GET",
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${accessToken}`
                        }
                    });
                    const data = await response.json();
                    console.log("success:", data);
                    this.list_plan = data.data;
                } catch (error) {
                    console.error("Upload error:", error);
                }
            },
      copyTextFallback(text) {
        const textarea = document.createElement("textarea");
        textarea.value = text;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
      },

      async deleteDevice(id) {
        try {
          var accessToken = localStorage.getItem("accessToken");
          const response = await fetch(`${process.env.VUE_APP_API_URL}/api/devices?deviceid=` + id, {
            method: 'DELETE',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${accessToken}`
            }
          });
          
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          this.getAllDevice()
        } catch (error) {
          console.error('Error fetching dashboard data:', error);
        }

      },
      async editDevice(id) {
        try {
          var body_create_device;
          if (this.device.mode == 'api') {
            if (this.api.type == 'apikey') {
              body_create_device = {
                "id": id,
                "name": this.device.name,
                "template_id": this.device.template_id,
                "plan_id": this.device.plan_id,
                "comment": this.device.comment,
                "mode": this.device.mode,
                "config": {
                  "auth": {
                    "type": this.api.type,
                    "in": this.api.in,
                    "key": this.api.key,
                    "value": this.api.value
                  },
                  "deviceId": this.device.model
                }
              }
            } else {
              body_create_device = {
                "id": id,
                "name": this.device.name,
                "template_id": this.device.template_id,
                "plan_id": this.device.plan_id,
                "comment": this.device.comment,
                "mode": this.device.mode,
                "config": {
                  "auth": {
                    "type": this.api.type,
                    "username": this.api.username,
                    "password": this.api.password,
                  },
                  "deviceId": this.device.model
                }
              }
            }
          } else if (this.device.mode == 'mqtt') {
            body_create_device = {
              "id": id,
              "name": this.device.name,
              "template_id": this.device.template_id,
              "plan_id": this.device.plan_id,
              "comment": this.device.comment,
              "mode": this.device.mode,
              "config": {
                 "topic": this.mqtt.topic,
                  "clientId": this.mqtt.clientId,
                  "username": this.mqtt.username,
                  "password": this.mqtt.password,
                // "auth": {
                //   "topic": this.mqtt.topic,
                //   "id": this.mqtt.id,
                //   "username": this.mqtt.username,
                //   "password": this.mqtt.password,
                // },
                "deviceId": this.device.model
              }
            }
          }

          var accessToken = localStorage.getItem("accessToken");
          const response = await fetch(`${process.env.VUE_APP_API_URL}/api/devices`, {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${accessToken}`
            },
            body: JSON.stringify(
              body_create_device
            )
          });

          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }

          const result = await response.json();
          this.$router.push('/device/list');

          console.log('device update:', result);
          alert("✅ Update Device สำเร็จ");
        } catch (error) {
          console.error('Error creating dashboard page:', error);
        }
      },

      async getAllDevice() {
        try {
          var accessToken = localStorage.getItem("accessToken");
          this.loading = true;
          const params = new URLSearchParams({
            ...(this.q ? { q: this.q } : {}),
            page: String(this.page),
            size: String(this.size),
          });
          const response = await fetch(`${process.env.VUE_APP_API_URL}/api/devices/all?` + params.toString(), {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${accessToken}`
            }
          });

          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }

          const data = await response.json();
          this.list_device = data.data;
          this.total = data?.meta?.total ;
        } catch (error) {
          console.error('Error fetching dashboard data:', error);
          this.list_group = [];
          this.total = 0;
        }finally {
        this.loading = false;
      }

      },
      reload() {
        this.page = 1;
        this.getAllDevice();
      },
      nextPage() {
        if (!this.disableNext) {
          this.page += 1;
          this.getAllDevice();
        }
      },
      prevPage() {
        if (this.page > 1) {
          this.page -= 1;
          this.getAllDevice();
        }
      },
      clearForm() {
        this.device = this.emptyDevice();
        this.api = this.emptyApiConfig();
        this.mqtt = this.emptyMqttConfig();
      },
    },
    watch: {
      size() {
        this.reload();
      },
    },
    mounted() {
      this.getAllDevice();
      this.getTemplateList();
      this.getPlanList();
    },
  };
</script>
